import React, { useState, Children } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, ShieldCheckIcon } from 'lucide-react';
export function HeroVariant3() {
  const [phone, setPhone] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitted(true);
    // Here you would normally send the data to your worker
  };
  const lineVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: 'easeOut'
      }
    }
  };
  return <section className="relative min-h-screen w-full overflow-hidden px-4 pt-24 pb-16 flex items-center bg-[#0A0A0A]" data-id="element-559">
      {/* Dark modern background with abstract shapes */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-560">
        <div className="absolute -top-[20%] -left-[10%] w-[70%] h-[70%] rounded-full bg-blue-600/20 blur-[120px]" data-id="element-561" />
        <div className="absolute top-[40%] -right-[10%] w-[50%] h-[50%] rounded-full bg-purple-600/20 blur-[120px]" data-id="element-562" />
      </div>

      <div className="relative z-10 mx-auto flex w-full max-w-7xl flex-col lg:flex-row items-center justify-between gap-16" data-id="element-563">
        {/* Left Content */}
        <div className="w-full lg:w-1/2 text-left" data-id="element-564">
          <motion.div initial="hidden" animate="show" variants={{
          show: {
            transition: {
              staggerChildren: 0.2
            }
          }
        }} data-id="element-565">
            <motion.h1 variants={lineVariants} className="text-5xl md:text-6xl lg:text-7xl font-bold tracking-tight mb-4 text-white leading-[1.1]" data-id="element-566">
              Сделаем сайт
            </motion.h1>
            <motion.h1 variants={lineVariants} className="text-5xl md:text-6xl lg:text-7xl font-bold tracking-tight mb-4 text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-400 leading-[1.1]" data-id="element-567">
              бесплатно.
            </motion.h1>
            <motion.h1 variants={lineVariants} className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight mb-8 text-gray-300 leading-[1.1]" data-id="element-568">
              Платишь только $10/мес.
            </motion.h1>

            <motion.p variants={lineVariants} className="text-lg md:text-xl mb-10 text-gray-400 font-medium max-w-lg" data-id="element-569">
              Сначала макет — потом решение. Не понравится — уходишь без оплаты.
              Разработка уже включена.
            </motion.p>

            <motion.div variants={lineVariants} className="flex items-center gap-6" data-id="element-570">
              <div className="flex -space-x-4" data-id="element-571">
                <img src="https://cdn.magicpatterns.com/uploads/etzGm3E7AqZzoRBR6LW1hA/nastyatoki.png" alt="User" className="w-12 h-12 rounded-full border-2 border-[#0A0A0A] object-cover bg-gray-800" data-id="element-572" />
                <img src="https://cdn.magicpatterns.com/uploads/kywdwn7LuPV87mnksEkraf/yourawesam.png" alt="User" className="w-12 h-12 rounded-full border-2 border-[#0A0A0A] object-cover bg-gray-800" data-id="element-573" />
                <div className="w-12 h-12 rounded-full border-2 border-[#0A0A0A] bg-gray-800 flex items-center justify-center text-white text-xs font-bold" data-id="element-574">
                  +500
                </div>
              </div>
              <p className="text-sm text-gray-400 font-medium" data-id="element-575">
                Довольных клиентов
                <br data-id="element-576" />
                по всему миру
              </p>
            </motion.div>
          </motion.div>
        </div>

        {/* Right Glassmorphism Form */}
        <motion.div initial={{
        opacity: 0,
        x: 50
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="w-full lg:w-[450px]" data-id="element-577">
          <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-[2rem] p-8 shadow-2xl relative overflow-hidden" data-id="element-578">
            {/* Inner glow */}
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-blue-400 to-purple-400" data-id="element-579" />

            <h3 className="text-2xl font-bold text-white mb-2" data-id="element-580">
              Куда прислать макет?
            </h3>
            <p className="text-gray-300 text-sm mb-8" data-id="element-581">
              Оставьте номер (Telegram/WhatsApp), мы свяжемся для уточнения
              деталей.
            </p>

            {isSubmitted ? <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} className="bg-green-500/20 border border-green-500/30 rounded-2xl p-6 text-center" data-id="element-582">
                <ShieldCheckIcon className="w-12 h-12 text-green-400 mx-auto mb-3" data-id="element-583" />
                <h4 className="text-white font-bold text-lg mb-1" data-id="element-584">
                  Заявка принята!
                </h4>
                <p className="text-green-200 text-sm" data-id="element-585">
                  Мы свяжемся с вами в течение 15 минут.
                </p>
              </motion.div> : <form onSubmit={handleSubmit} className="space-y-5" data-id="element-586">
                <div data-id="element-587">
                  <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-588">
                    Ваш телефон
                  </label>
                  <input type="tel" required value={phone} onChange={e => setPhone(e.target.value)} placeholder="+1 234 567 8900" className="w-full bg-black/20 border border-white/10 rounded-xl px-5 py-4 text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all" data-id="element-589" />
                </div>

                <button type="submit" className="w-full bg-gradient-to-r from-blue-500 to-purple-500 text-white rounded-xl px-5 py-4 font-bold text-lg hover:opacity-90 transition-opacity flex items-center justify-center gap-2 shadow-lg" data-id="element-590">
                  Жду макет
                  <ArrowRightIcon className="w-5 h-5" data-id="element-591" />
                </button>

                <p className="text-xs text-gray-400 text-center mt-4 flex items-center justify-center gap-1" data-id="element-592">
                  <ShieldCheckIcon className="w-4 h-4" data-id="element-593" />
                  Ваши данные надежно защищены
                </p>
              </form>}
          </div>
        </motion.div>
      </div>
    </section>;
}